import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";

import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import ListItemIcon from '@mui/material/ListItemIcon';
import SvgIcon from "@mui/material/SvgIcon";
import TwitterIcon from '@mui/icons-material/Twitter';

import {LookShareIcons} from "../../../../common/icons";
import {setLookOverlayOpened, setLookReturnAction} from "../../../../../actions/lookFunctions";
import {LOOK_OVERLAYS} from "../../../core/constants";
import {saveQuoteAndShare} from "../../lookFunctions2";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";
import {pricingIsLocked} from "../../lookNavigationFunctions";

export const SHARE_BUTTONS = {
  facebook: "facebook",
  pinterest: "pinterest",
  twitter: "twitter",
}

export const getShareConfig = ({height, width}) => {
  const left = window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - width / 2;
  const top = window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - height / 2;
  const config = {
    height: height,
    width: width,
    left: left,
    top: top,
    location: 'no',
    toolbar: 'no',
    status: 'no',
    directories: 'no',
    menubar: 'no',
    scrollbars: 'yes',
    resizable: 'no',
    centerscreen: 'yes',
    chrome: 'yes'
  }
  return Object.keys(config).map(key => key + '=' + config[key]).join(', ');
};

const LookSideBarShareButtons = (props) => {

  const {handleClose, userIsLoggedIn, propsShareUrl, setLookOverlayOpened, setLookReturnAction} = props;

  const shareClickButton = (buttonKey) => {
    switch (buttonKey) {
      case SHARE_BUTTONS.facebook:
        Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookSidebarFacebook);
        break;
      case SHARE_BUTTONS.twitter:
        Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookSidebarTwitter);
        break;
      case SHARE_BUTTONS.pinterest:
        Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookSidebarPinterest);
        break;
      default:
        break;
    }
    if (!userIsLoggedIn) {
      const {isLixil} = pricingIsLocked();
      if (isLixil) {
        setLookOverlayOpened(LOOK_OVERLAYS.questionShare);
        setLookReturnAction(buttonKey);
      } else {
        setLookOverlayOpened(LOOK_OVERLAYS.leadCapture, buttonKey);
      }
      return false;
    }

    handleClose();
    // if (jobId) {
    //   shareLogic(buttonKey)
    // } else {
    saveQuoteAndShare(buttonKey, propsShareUrl);
    // }
  }

  return (
    <MenuList autoFocusItem={false} id="menu-list-grow">
      {Object.keys(SHARE_BUTTONS).map(buttonKey => {
        const icon = (buttonKey === "twitter") ? <TwitterIcon/> : <SvgIcon>{LookShareIcons[buttonKey]}</SvgIcon>;
        return (
          <MenuItem className="look-sidebar__modal-item"
                    key={buttonKey}
                    data-id={buttonKey}
                    onClick={() => shareClickButton(buttonKey)}>
            <ListItemIcon>{icon}</ListItemIcon>
            <FormattedMessage id={`share.${buttonKey}`}/>
          </MenuItem>
        )
      })}
    </MenuList>
  )
};

LookSideBarShareButtons.propTypes = {
  handleClose: PropTypes.func.isRequired,
}

const mapStateToProps = (store) => {
  const {userIsLoggedIn} = store.userState;
  const {shareUrl} = store.serverState;
  return {
    userIsLoggedIn,
    propsShareUrl: shareUrl,
  };
};

const mapDispatchToProps = {
  setLookOverlayOpened,
  setLookReturnAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(LookSideBarShareButtons)
